<div class="us-container">

  <!-- ── Processing counts bar ────────────────────────────── -->
  <div class="us-counts-bar" *ngIf="showCountsBar">
    <div class="us-count-item">
      <span class="us-count-label">User Stories Identified :</span>
      <span class="us-count-value">{{ counts.identified }}</span>
      <span class="us-count-new" *ngIf="counts.newCount > 0" [title]="counts.newCount + ' new'">N</span>
    </div>
    <span class="us-count-sep" aria-hidden="true"></span>
    <div class="us-count-item">
      <span class="us-count-label">Extraction Completed :</span>
      <span class="us-count-value">{{ counts.extractionCompleted }}</span>
    </div>
    <span class="us-count-sep" aria-hidden="true"></span>
    <div class="us-count-item">
      <span class="us-count-label">Extraction Pending :</span>
      <span class="us-count-value">{{ counts.extractionPending }}</span>
    </div>
    <span class="us-count-sep" aria-hidden="true" *ngIf="isRciEnabled"></span>
    <div class="us-count-item" *ngIf="isRciEnabled">
      <span class="us-count-label">RCI Generated :</span>
      <span class="us-count-value">{{ counts.rciGenerated }}</span>
    </div>
    <span class="us-count-sep" aria-hidden="true"></span>
    <div class="us-count-item">
      <span class="us-count-label">Knowledge Graph Generating </span>
      <span
        class="spinner-border spinner-border-sm us-count-spinner"
        role="status"
        aria-label="Knowledge graph generating"
      ></span>
    </div>
  </div>

  <!-- ── Toolbar ──────────────────────────────────────────── -->
  <div class="us-toolbar">
    <div class="us-toolbar-left">
      <label class="us-select-all-wrap" [class.us-select-all-wrap--disabled]="isSelectionDisabled">
        <input type="checkbox" class="us-checkbox"
          [(ngModel)]="isSelectAllChecked"
          [disabled]="isSelectionDisabled"
          (change)="toggleSelectAll()" />
        <span class="us-select-all-label">Select all</span>
      </label>

      <span class="us-sep">|</span>

      <span class="us-pagination-info">
        <strong>{{ startItem }}</strong> - <strong>{{ endItem }}</strong>
        of <strong>{{ totalItems }}</strong>
      </span>

      <div class="us-page-nav">
        <button class="us-page-btn" [disabled]="pageIndex === 0" (click)="prevPage()" aria-label="Previous page">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 1L1 6L6 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="us-page-btn" [disabled]="pageIndex >= totalPages - 1" (click)="nextPage()" aria-label="Next page">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="us-toolbar-right" *ngIf="!showCountsBar">
      <span
        class="us-kg-btn-wrap"
        [matTooltip]="isProcessing ? kgWaitingTooltip : ''"
        [matTooltipDisabled]="!isProcessing"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip"
      >
        <button
          type="button"
          class="us-action-btn us-action-btn--outline"
          [disabled]="!canUseActions"
          (click)="openKnowledgeGraph()"
        >
          <span
            *ngIf="isProcessing"
            class="spinner-border spinner-border-sm us-kg-spinner"
            role="status"
            aria-hidden="true"
          ></span>
          View Knowledge Graph
        </button>
      </span>
      <span
        class="us-kg-btn-wrap"
        [matTooltip]="isProcessing ? generateWaitingTooltip : ''"
        [matTooltipDisabled]="!isProcessing"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip"
      >
        <button
          type="button"
          class="us-action-btn us-action-btn--primary"
          [disabled]="!canUseActions"
          (click)="openGenerateModal()"
        >
          Generate Test Cases
        </button>
      </span>
    </div>
  </div>

  <!-- ── Story list ────────────────────────────────────────── -->
  <div class="us-list">
    <app-expandable-accordion
      *ngIf="totalItems > 0"
      [data]="accordionData"
      [showHeader]="false"
      [showSelectAll]="false"
      [selectionDisabled]="isSelectionDisabled"
      [templateId]="'expandable_detail_table'"
      (actionEmit)="onAccordionAction($event)">
    </app-expandable-accordion>

    <!-- In-progress with no rows yet: geometric progress loader -->
    <app-morph-box-loader
      *ngIf="totalItems === 0 && isProcessing"
      [message]="loaderMessage">
    </app-morph-box-loader>

    <ng-container *ngIf="totalItems === 0 && !isProcessing">
      <app-no-data></app-no-data>
    </ng-container>
  </div>

</div>
